var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBenefitMainIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 200,
    viewBox: "0 0 223 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.079 69.2271C191.409 69.2271 200.595 60.0281 200.595 48.6805C200.595 37.3328 191.409 28.1338 180.079 28.1338C168.748 28.1338 159.562 37.3328 159.562 48.6805C159.562 60.0281 168.748 69.2271 180.079 69.2271Z",
    fill: "#009989"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.825 44.5208C179.582 43.3274 182.021 41.3544 182.837 40.9244C185.812 39.3644 190.382 40.5408 192.013 43.5208C195.748 50.3541 185.247 60.0974 179.828 62.5008C179.202 62.0008 164.368 50.8874 167.846 43.7741C171.324 36.6608 178.966 40.2774 179.825 44.5208Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.868 93.9772V25.0005C125.866 23.0025 125.072 21.0869 123.661 19.6742C122.25 18.2612 120.338 17.4665 118.343 17.4639H22.1533C20.1611 17.4709 18.2528 18.2675 16.8457 19.6799C15.4386 21.0922 14.6472 23.0052 14.6445 25.0005V161.764C14.6472 163.76 15.4413 165.674 16.8524 167.085C18.2635 168.496 20.1761 169.288 22.1699 169.287H118.359C119.292 169.293 120.218 169.116 121.082 168.764",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2169 22.5793H116.296C119.442 22.5793 121.993 25.1338 121.993 28.286V158.486C121.993 161.639 119.442 164.193 116.296 164.193H24.2169C21.0711 164.193 18.5195 161.639 18.5195 158.486V28.286C18.5195 25.1338 21.0711 22.5793 24.2169 22.5793Z",
    fill: "white",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.387 33.1172H27.2706C25.5592 33.1172 24.1719 34.5065 24.1719 36.2205V56.7138C24.1719 58.4275 25.5592 59.8172 27.2706 59.8172H114.387C116.098 59.8172 117.486 58.4275 117.486 56.7138V36.2205C117.486 34.5065 116.098 33.1172 114.387 33.1172Z",
    fill: "#EAEAEA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2553 44.3646C71.779 44.3646 73.0145 43.1272 73.0145 41.6012C73.0145 40.0749 71.779 38.8379 70.2553 38.8379C68.7316 38.8379 67.4961 40.0749 67.4961 41.6012C67.4961 43.1272 68.7316 44.3646 70.2553 44.3646Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5524 54.0977C62.5311 53.071 62.7145 52.0507 63.0923 51.0957C63.4697 50.141 64.0339 49.2714 64.7512 48.538C65.4688 47.8044 66.3251 47.2214 67.2704 46.8237C68.2156 46.4257 69.2305 46.2207 70.2559 46.2207C71.2814 46.2207 72.2962 46.4257 73.2415 46.8237C74.1867 47.2214 75.0431 47.8044 75.7607 48.538C76.478 49.2714 77.0421 50.141 77.4196 51.0957C77.7973 52.0507 77.9807 53.071 77.9594 54.0977H62.5524Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5039 71.7363H106.059",
    stroke: "white",
    strokeWidth: 5.4,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5039 78.8906H106.059",
    stroke: "white",
    strokeWidth: 5.4,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5039 124.951H106.059",
    stroke: "#EAEAEA",
    strokeWidth: 5.4,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3535 131.714H89.2054",
    stroke: "#EAEAEA",
    strokeWidth: 5.4,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6693 99.7574L51.8813 105.924L44.2793 98.764L50.0706 92.6007C51.0206 91.5947 52.3296 91.0061 53.7119 90.9634C55.0938 90.9211 56.4365 91.4281 57.4463 92.3741C58.4471 93.3271 59.0319 94.6374 59.0735 96.0197C59.1155 97.4024 58.6109 98.7454 57.6693 99.7574Z",
    fill: "#FAA61B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.166 95.7432C79.9197 94.5499 82.3627 92.5765 83.1615 92.1465C86.1337 90.5865 90.7069 91.7632 92.3345 94.7432C96.0722 101.577 85.5712 111.317 80.1493 113.723C79.5269 113.223 64.6925 102.11 68.1673 94.9965C71.6421 87.8832 79.3039 91.4965 80.166 95.7432Z",
    fill: "#FF0000"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9727 107.924H77.0572",
    stroke: "#FAA61B",
    strokeWidth: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0137 111.971V103.874",
    stroke: "#FAA61B",
    strokeWidth: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M151.255 87C142.244 87.0003 133.392 89.3761 125.588 93.8886C117.784 98.401 111.304 104.891 106.798 112.707C102.291 120.521 99.918 129.387 99.918 138.412C99.918 147.436 102.291 156.302 106.798 164.117C111.304 171.932 117.784 178.422 125.588 182.935C133.392 187.447 142.244 189.823 151.255 189.823C160.266 189.823 169.118 187.447 176.922 182.935C184.726 178.422 191.206 171.932 195.712 164.117C200.217 156.301 202.589 147.436 202.589 138.412C202.589 129.387 200.217 120.522 195.712 112.707C191.206 104.891 184.726 98.401 176.922 93.8886C169.118 89.3761 160.266 87.0003 151.255 87Z",
    fill: "#313283"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M163.166 125.384L161.795 124.418L175.711 104.421L177.082 105.388L163.166 125.384Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M138.238 155.938L134.199 161.72L137.846 164.274L141.884 158.492L138.238 155.938Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M165.524 130.617L146.519 157.827C145.521 159.277 143.826 159.854 142.761 159.111L137.363 155.334C136.301 154.591 136.268 152.814 137.28 151.361L156.284 124.151C157.283 122.701 158.977 122.121 160.042 122.867L165.441 126.647C166.503 127.387 166.536 129.164 165.524 130.617Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M142.267 170.567C141.898 171.114 141.369 171.532 140.753 171.764C140.502 171.87 140.229 171.912 139.958 171.888C139.687 171.863 139.426 171.773 139.198 171.624L126.884 162.987C126.018 162.381 125.998 160.914 126.82 159.737C127.19 159.187 127.722 158.767 128.341 158.534C128.593 158.434 128.864 158.395 129.134 158.421C129.402 158.447 129.662 158.537 129.889 158.684L142.204 167.321C143.053 167.924 143.079 169.384 142.267 170.567Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitMainIcon2);
export default __webpack_public_path__ + "static/media/benefit_main_icon2.73ccbdbc.svg";
export { ForwardRef as ReactComponent };